export default __webpack_public_path__ + "static/media/AvenirNextW10-UltraLight.60b9fcd3.woff2";